import { ANSWER_STATUSES, PAGINATOR_BUTTON_VIEW } from '../../../constants';

export const getDesktopView = (status?: ANSWER_STATUSES, hidden?: boolean): PAGINATOR_BUTTON_VIEW => {
    if (hidden) {
        return PAGINATOR_BUTTON_VIEW.EXTRA_DARK;
    }
    if (status === ANSWER_STATUSES.CORRECT) {
        return PAGINATOR_BUTTON_VIEW.GREEN;
    }
    if (status === ANSWER_STATUSES.INCORRECT) {
        return PAGINATOR_BUTTON_VIEW.ORANGE;
    }
    return PAGINATOR_BUTTON_VIEW.DEFAULT;
};
